import { useMemo } from 'react'
import { TSettingsKey, useGetSettings, useUpdateSetting } from '../services/api/settings.hooks'
import { TSetting } from '../utils/types'
import { emptyFunction } from '../utils/utils'

export type TSettingValue = string | number | boolean
interface SettingResult extends TSetting {
    isLoading: boolean
    updateSetting: (value: TSettingValue) => void
}
const useSetting = (settingKey?: TSettingsKey, isEnabled = true): SettingResult => {
    const shouldLoadSetting = isEnabled && Boolean(settingKey)
    const { data, isLoading } = useGetSettings(shouldLoadSetting)
    const { mutate } = useUpdateSetting()

    return useMemo(() => {
        if (!settingKey) {
            return {
                isLoading: false,
                field_key: '',
                field_value: '',
                field_name: '',
                choices: [],
                updateSetting: emptyFunction,
            }
        }

        const setting = data?.find((setting) => setting.field_key === settingKey)

        if (isLoading || !data) {
            return {
                isLoading: true,
                field_key: settingKey,
                field_value: '',
                field_name: '',
                choices: [],
                updateSetting: emptyFunction,
            }
        }

        if (!setting) {
            return {
                isLoading: false,
                field_key: settingKey,
                field_value: '',
                field_name: '',
                choices: [],
                updateSetting: emptyFunction,
            }
        }

        const updateSetting = (value: TSettingValue) => {
            mutate({ key: settingKey, value: String(value) })
        }

        return {
            ...setting,
            isLoading: false,
            updateSetting,
        }
    }, [data, isLoading, settingKey, mutate])
}

export default useSetting
